import { PageTrade as Trade } from './Trade';
import styles from "./index.module.scss";
import { RootHeader } from "@/components/RootHeader";
import { ContentTabs } from "./components/ContentTabs";
export const PageTrade = () => {
  return <div className={styles.pageTrade} data-sentry-component="PageTrade" data-sentry-source-file="index.tsx">

    <RootHeader title={'挂单市场'} data-sentry-element="RootHeader" data-sentry-source-file="index.tsx" />
    <ContentTabs active={'trade'} data-sentry-element="ContentTabs" data-sentry-source-file="index.tsx" />
    <Trade data-sentry-element="Trade" data-sentry-source-file="index.tsx" />
    <div className={styles.whitespace}></div>
  </div>;
};